import { useEffect, useState, memo } from 'react';
import './style.scss';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from '../sidebar';
import Header from '../header';
import methodModel from '../../../methods/methods';
import WebsiteLogo from '../WebsiteSettings/WebsiteLogo';
import { FiMenu } from 'react-icons/fi';
import { LuArrowRightFromLine } from 'react-icons/lu';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

const Layout = memo(({ children }) => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      navigate('/login');
    }
  }, [navigate]);

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  const router = () => {
    const route = localStorage.getItem('route');
    if (route) {
      navigate(route);
    }
  };

  return (
    <div>
      <div onClick={router} id="routerDiv" />

      <Header isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`main-wrapper bg-[#221E10] flex ${isOpen ? 'active-sidebar' : ''}`}>
        
        <button
          onClick={toggle}
          className="btntoggle absolute left-[250px] top-[38px] h-8 w-8 shrink-0 shadow-btn hover:shadow-none rounded-full !text-white bg-[#CC9900] z-[999] transition-[width] duration-300 p-1"
        >
          {!isOpen ? (
            <IoIosArrowBack className="w-full h-full" />
          ) : (
            <IoIosArrowForward className="w-full h-full" />
          )}
        </button>

        <div className="main-sidebar scrollbar transition-[width] duration-300">
          <div className="flex flex-col h-full justify-between">
            
            <div className="w-full">
              
              <div className="sidebar-brand text-center">
                <Link to="/">
                  <div className="editLogo">
                    <WebsiteLogo className="h-20 w-full object-contain rounded-lg" />
                  </div>
                </Link>
              </div>

              {user?.logo && (
                <div className="flex justify-center items-center">
                  <img
                    src={methodModel.userImg(user.logo)}
                    alt="photo"
                    className="w-12 h-12 object-cover rounded-full mb-2"
                  />
                </div>
              )}

              <Sidebar isOpen={isOpen} />
            </div>

          </div>
        </div>

        <main className="main rounded-[20px]">
          <div className="mainarea rounded-b-[20px]">
            {children}
          </div>
        </main>

      </div>
    </div>
  );
});

export default Layout;